import { FC, useCallback, useState } from 'react';

import { Box, IconButton, Menu } from '@mui/material';

import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrowDown.svg';
import { ReactComponent as AvatarIcon } from 'assets/icons/avatarFilled.svg';
import { CommonButton, UserMenuOptions } from 'components';
import { usePathnameChange, useUserMenu } from 'hooks';
import { styles } from './styles';

export const UserMenu: FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = !!anchorEl;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  usePathnameChange({ handleAction: handleClose });

  const {
    isAvatartButton,
    isBuyer,
    isModalOpen,
    isMultiRole,
    menuTitle,
    changeUser,
    handleCloseModal,
    handleOpenCompanyProfile,
    handleOpenModal,
    handleOpenChangePassword,
    handleGoToInventoryPage,
  } = useUserMenu({
    onAction: handleClose,
  });

  return (
    <>
      {isAvatartButton ? (
        <Box sx={styles.iconButtonWrap}>
          <IconButton onClick={handleClick}>
            <AvatarIcon />
          </IconButton>
        </Box>
      ) : (
        <CommonButton sx={{ ...styles.menuButton }} onClick={handleClick}>
          <span>{menuTitle}</span>
          <Box sx={{ ...styles.menuButtonIcon }}>
            <ArrowDownIcon />
          </Box>
        </CommonButton>
      )}
      <Menu
        sx={{ ...styles.menuWrap }}
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: -8,
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <UserMenuOptions
          isBuyer={isBuyer}
          isModalOpen={isModalOpen}
          isMultiRole={isMultiRole}
          changeUser={changeUser}
          handleCloseModal={handleCloseModal}
          handleOpenCompanyProfile={handleOpenCompanyProfile}
          handleOpenModal={handleOpenModal}
          handleOpenChangePassword={handleOpenChangePassword}
          handleGoToInventoryPage={handleGoToInventoryPage}
        />
      </Menu>
    </>
  );
};
